import { Outlet } from 'react-router-dom'

import PartnerThemeWrapper from '~/features/partners/components/partnerThemeWrapper'

/** Admin portal config routes (General Settings, Branding) preview partner theming. */
function AdminPortalPartnerThemeOutlet() {
  return (
    <PartnerThemeWrapper>
      <Outlet />
    </PartnerThemeWrapper>
  )
}

export default AdminPortalPartnerThemeOutlet
